import * as jsonpatch from 'fast-json-patch';
import Headroom from 'headroom.js';

(function() {
  "use strict";

  angular.module("PrintixUtils", [])

    .filter("containsUppercaseAndLowerCase", function() {
      return function(input) {
        if (input.toLowerCase() !== input &&
        input.toUpperCase() !== input) {
          return true;
        } else {
          return false;
        }
      };
    })

    .directive("goToUrl", ["$window", "$location", "$parse",
      function($window, $location, $parse) {
        return function(scope, element, attrs) {
          element.on("click", function() {
            scope.$apply(function() {
              var url = attrs.goToUrl.split(" ")[0];
              var urlParams = attrs.urlParam;
              if (url) {
                if (url.indexOf("http") > -1) {
                  if (urlParams) {
                    $window.open(url).search(urlParams);
                  } else {
                    $window.open(url);
                  }
                } else {
                  if (urlParams) {
                    $location.path(url).search(urlParams, attrs.goToUrlParams);
                  } else {
                    $location.path(url);
                  }
                }
              }
            });
          });
        };
      }
    ])

    .directive('ngRightClick',
      ['$parse',
      function($parse) {
        return function (scope, element, attrs) {
          var fn = $parse(attrs.ngRightClick);
          element.on('contextmenu', function(event) {
            scope.$apply(function() {
              event.preventDefault();
              fn(scope, {$event: event})
            })
          })
        }
      }
    ])

    .directive('clickAndHold',
      ['$parse', '$timeout', '$document',
      function($parse, $timeout, $document) {
        return function (scope, element, attrs) {
          var fn = $parse(attrs.clickAndHold);
          var holding = false;
          var startX = 0;
          var startY = 0;
          var x = 0;
          var y = 0;
          var container = null;

          element.on('dragenter', function(event) {

            $timeout(function() {
              holding = true;
              fn(scope, {holding: holding});
              startX = event.offsetX;
              startY = event.offsetY;
              $document.on('mousemove', mousemove);
              $document.on('mouseup', mouseup);
              container = attrs.$$element;
            }, 500)
          })

          function mousemove() {
            x = event.clientX - startX;
            y = event.clientY - startY;
            container.css({
              top: y + 'px',
              left: x + 'px'
            });
          }

          function mouseup() {
            holding = false;
            fn(scope, {holding: holding});
            $document.off('mousemove', mousemove);
            $document.off('mouseup', mouseup);
          }

        }
      }
    ])


    .directive('dragableChild', ['$document',
    function($document){
        return function(scope, element, attr) {
          var startX = 0;
          var startY = 0;
          var x = 0;
          var y = 0;
          var container = null;

          element.on('mousedown', function(event) {
            if (attr.$$element.parent().parent()[0].classList.value.indexOf('grabable') > -1 ) {
              startX = event.offsetX  + 200;
              startY = event.offsetY - 45;
              $document.on('mousemove', mousemove);
              $document.on('mouseup', mouseup);
              container = attr.$$element.parent().parent();
            }
          });

          function mousemove(event) {
            x = event.clientX - startX;
            y = event.clientY - startY;
            container.css({
              top: y + 'px',
              left: x + 'px'
            });
          }

          function mouseup() {
            $document.off('mousemove', mousemove);
            $document.off('mouseup', mouseup);
          }
        }
      }
    ])

    .directive('dragable', ['$document',
    function($document){
        return function(scope, element, attr) {
          var startX = 0;
          var startY = 0;
          var x = 0;
          var y = 0;
          var container = null;

          element.on('mousedown', function(event) {
            if (event.target.classList.value.indexOf('grabable') > -1 || event.target.classList.value.indexOf('grabable-container') > -1 ) {
              startX = event.clientX;
              startY = event.clientY;
              $document.on('mousemove', mousemove);
              $document.on('mouseup', mouseup);
              container = attr.$$element;
              x = Number(container[0].style.left.replace('px',''));
              y = Number(container[0].style.top.replace('px',''));
              event.stopPropagation();
            }
          });

          function mousemove(event) {
            const currX = event.clientX;
            const currY = event.clientY;
            x += currX - startX;
            y += currY - startY;
            startX = currX;
            startY = currY;
            container.css({
              top: y + 'px',
              left: x + 'px'
            });
          }

          function mouseup() {
            $document.off('mousemove', mousemove);
            $document.off('mouseup', mouseup);
          }
        }
      }
    ])

    .directive('dragableHorizontal', ['$document', '$window', 'localStorageService', '$cookies',
      function($document, $window, localStorageService, $cookies){
        return function(scope, element, attr) {
          var outsideGutter = 0;

          var storageObject = null;
          if (localStorageService.isSupported) {
            storageObject = localStorageService;
          } else {
            storageObject = $cookies;
            storageObject.set = function(key, value) {
              return storageObject.put(key, value);
            };
          }

          element.on('mousedown', function(event) {
            if (event.target.classList.value.indexOf('grabableResize') > -1 ) {
              outsideGutter = ($window.innerWidth - angular.element('.container')[0].clientWidth) / 2;
              angular.element('.structure-toolbar').css({width: event.clientX - (outsideGutter + 20)})
              angular.element('.sites-tree-container').css({width: event.clientX - (outsideGutter + 20)})
              angular.element('.sites-container').css({width: angular.element('.container')[0].clientWidth - (angular.element('.sites-tree-container')[0].clientWidth + 55)});
              $document.on('mousemove', mousemove);
              $document.on('mouseup', mouseup);
            }
          });

          function mousemove(event) {
            storageObject.set('sitesRelativeWidth', event.clientX - (outsideGutter + 20));
            angular.element('.structure-toolbar').css({width: event.clientX - (outsideGutter + 20)})
            angular.element('.sites-tree-container').css({width: event.clientX - (outsideGutter + 20)})
            angular.element('.sites-container').css({width: angular.element('.container')[0].clientWidth - (angular.element('.sites-tree-container')[0].clientWidth + 55)});
          }

          function mouseup() {
            $document.off('mousemove', mousemove);
            $document.off('mouseup', mouseup);
          }
        }
      }
    ])

    .directive("addRootClass", function() {
      return {
        restrict: "A",
        scope: {
          classes: "=addRootClass"
        },
        link: function(scope, element, attributes) {
          document.documentElement.classList.add(scope.classes);
          scope.$on("$destroy", function() {
            document.documentElement.classList.remove(scope.classes);
          });
        }
      };
    })

    .directive("autoResizeMenu", ["Utils", function(Utils) {
      return {
        restrict: "A",
        link: function(scope, element, attributes) {
          angular.element('.navbar .dropdown').on('shown.bs.dropdown', function() {
            Utils.adjustMenuDropDowns();
          });

          var resizeTimer;

          angular.element(window).on('resize', function(e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              Utils.adjustMenuDropDowns();
            }, 250);
          });
        }
      };
    }])

    // Adjusts the height of the input control to match the content.
    .directive('autoResizeInput', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          element.css('overflow', 'hidden');
          scope.$watch(attrs.ngModel, function () {
            adjustHeight();
          });

          function adjustHeight() {
            // if the content is empty, set the height to default
            if (element[0].scrollHeight === 0) {
              element[0].style.height = '';
            } else {

              // Resize the control to fit the content
              element[0].style.height = 'auto';
              element[0].style.height = element[0].scrollHeight + 'px';
              // Check for a minimum height
              if (element[0].scrollHeight < element[0].minHeight) {
                element[0].style.height = element[0].minHeight + 'px';
              }
              // Check for a maximum height
              if (element[0].scrollHeight > element[0].maxHeight) {
                element[0].style.height = element[0].maxHeight + 'px';
              }
            }
          }
        }
      };
    })

    .directive("headroom", function() {
      return {
        restrict: "C",
        scope: {
          toleranceUp: "=toleranceUp",
          toleranceDown: "=toleranceDown"
        },
        link: function(scope, element, attributes) {
          var headroom = new Headroom(document.querySelector(".headroom"), {
            tolerance: {
              down: scope.toleranceDown,
              up: scope.toleranceUp
            }
          });
          headroom.init();

        }
      };
    })

    .directive("tooltipTitle", ["$filter", "$translate", "$timeout",
      function($filter, $translate, $timeout) {
        return {
          restrict: "A",
          scope: {
            tooltipTitle: "=tooltipTitle"
          },
          link: function(scope, element, attributes) {
            scope.$watch(function() {
              return $translate.use();
            }, function() {
              element.tooltip("destroy");
              if (angular.element("html").hasClass("no-touchevents")) {
                $timeout(function() {
                  var tranlatedTitle = $filter("translate")(scope.tooltipTitle);
                  if (tranlatedTitle === scope.tooltipTitle) {
                    tranlatedTitle = '';
                  }
                  element.tooltip({title: tranlatedTitle});
                }, 300);
              }
            });
          }
        };
      }
    ])

    .directive("confirmOnExit", ["$window", "$filter", "$translate", "$ngBootbox", "$location", "$rootScope", "CopilotService",
      function($window, $filter, $translate, $ngBootbox, $location, $rootScope, CopilotService) {

        return {
          link: function(scope, elem, attrs) {
            var message = "";
            scope.$watch(function() {
              return $translate.use();
            }, function() {
              message = $filter("translate")("DiscardChanges");
            });
            $window.onbeforeunload = function() {
              var form = scope[attrs.name];
              if (form) {
                if (form.$dirty) {
                  return message;
                }
              }
            };
            scope.$watch(function () {
              // watch the $dirty flag on the form and notify the CopilotService when it changes
              return scope[attrs.name] ? scope[attrs.name].$dirty : false;
            }, function () {
              var form = scope[attrs.name];
              if (form) {
                CopilotService.setFormDirty(form.$dirty);
              }
            }
            );
            scope.$on("$locationChangeStart", function(event, next, current) {
              var form = scope[attrs.name];
              if (form) {
                if (form.$dirty) {
                  event.preventDefault();
                  $ngBootbox.confirm(message).then(function() {
                    form.$dirty = false;
                    if (attrs.redirectUrl) {
                      $location.path(attrs.redirectUrl);
                    } else {
                      var path = next.substring($location.absUrl().length - $location.url().length);
                      path = path.split('?');
                      $location.path(path[0]);
                    }
                  }).catch(function(error){});
                }
              }
            });
          }
        };
      }
    ])

    .directive("preventFormDualSubmit", function() {
      return {
        restrict: "A",
        scope: {
          form: "=preventFormDualSubmit"
        },
        link: function(scope, element, attributes) {
          if (!scope.form.__customProperties) {
            scope.form.__customProperties = {};
          }
          scope.form.__customProperties.waitingForAnswer = false;
          var btn = angular.element(element);
          scope.$watch(function() {
            return scope.form.__customProperties;
          }, function() {
            if (scope.form.__customProperties &&
              scope.form.__customProperties.waitingForAnswer) {
              btn.addClass("disabled");
              btn.attr("disabled", "disabled");
            } else {
              btn.removeClass("disabled");
              btn.attr("disabled", null);
            }
          }, true);
        }
      };
    })

    .directive("ngIndeterminate", function() {
      return {
        restrict: "A",
        scope: {
          ngIndeterminate: "=ngIndeterminate"
        },
        link: function(scope, element, attributes) {
          scope.$watch(function() {
            return scope.ngIndeterminate;
          }, function() {
            if (attributes["id"]) {
              var checkbox = document.getElementById(attributes["id"]);
              if (checkbox) {
                checkbox.indeterminate = scope.ngIndeterminate;
              } else {
                throw "ngIndeterminate: checkbox is not found";
              }
            } else {
              throw "ngIndeterminate: id attribute is required";
            }
          });
        }
      };
    })

    .directive("addBootstrapPopOver", ["$translate", "$timeout", "$filter",
      function($translate, $timeout, $filter) {
        return {
          restrict: "A",
          scope: {
            addBootstrapPopOver: "=addBootstrapPopOver"
          },
          link: function(scope, element, attributes) {
            scope.$watch(function() {
              return $translate.use();
            }, function() {
              element.popover("destroy");
              $timeout(function() {
                element.popover({
                  trigger: "hover",
                  html: true,
                  title: $filter("translate")(scope.addBootstrapPopOver)
                });
              }, 300);
            });
          }
        };
      }
    ])

    .directive('pxReady', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attributes) {
          const value = attributes.pxReady;
          if (value) {
            scope.$evalAsync(value);
          }
        }
      };
    })

    .service("Utils", ["$rootScope", "$filter", "$translate", "$location", "USER_ROLES", "URLS",
      function($rootScope, $filter, $translate, $location, USER_ROLES, URLS) {

        this.evalJs = function(string) {
          if (string) {
            return eval("(function(){" + string + "}())");
          } else {
            throw "Utils.evalJs: string is missing";
          }
        };

        this.objectPropertiesCheck = function(obj, arr, checkIfDefined) {
          if (!obj || !arr) {
            return false;
          }
          var i = 0,
            length = arr.length,
            arrElem = null;
          for (; i < length; i++) {
            arrElem = arr[i].split(".");
            if (Array.isArray(arrElem) && arrElem.length > 1) {
              if (!this.objectPropertiesCheck(obj[arrElem[0]], [arrElem.slice(1, arrElem.length).join(".")])) {
                return false;
              }
            } else {
              if (!obj || !obj.hasOwnProperty(arrElem[0])) {
                return false;
              }
              if (checkIfDefined && angular.isUndefined(obj[arrElem])) {
                return false;
              }
            }
          }
          return true;
        };

        this.isObjectEmpty = function(obj) {
          return angular.equals({}, obj);
        };

        this.getObjectsDifferencesForPatching = function(objectOriginal, objectChanged) {
          if (objectOriginal && objectChanged) {
            var arrayWithPatchingObjects = jsonpatch.compare(objectOriginal, objectChanged);
            //removes any _link patching from the object array
            for (var i = arrayWithPatchingObjects.length - 1; i >= 0; i--) {
              if (arrayWithPatchingObjects[i].path.indexOf("_link") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("version") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("_embedded") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("$$hashKey") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("airPrintHost") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("airPrintPort") !== -1) {
                arrayWithPatchingObjects.splice(i, 1);
              }
            }
            //fix hack for adding element in array at the last position
            angular.forEach(arrayWithPatchingObjects, function(obj) {
              var objectPathSplitted = obj.path.split("/");
              if (obj.op === "add" &&
                objectPathSplitted.length > 1 && !isNaN(+objectPathSplitted[objectPathSplitted.length - 1]) &&
                angular.isNumber(+objectPathSplitted[objectPathSplitted.length - 1])) {
                objectPathSplitted[objectPathSplitted.length - 1] = "-";
              }
              obj.path = objectPathSplitted.join("/");
            });
            //fix hack for adding element in array at the last position
            return arrayWithPatchingObjects;
          } else {
            throw "Utils.getObjectsDifferencesForPatching: objectOriginal or objectChanged are missing";
          }
        };

        this.removeDomainFromUrl = function(url) {
          return url.split("printix.net/")[1];
        }

        // Check if dropdowns exceed the device viewport to prevent menu items in long dropdowns
        // from being inaccessible. This occurs because of the fixed header.
        this.adjustMenuDropDowns = function() {
          var overflow_css_class = "dropdown-menu--compact";
          var dropDowns = angular.element(".navbar .dropdown-menu");

          // always add overflow by default to be able to check if the
          // scroll-height exceeds the dropdown height
          dropDowns.addClass(overflow_css_class);

          // run over all dropdowns and check if we need to remove the overflow
          dropDowns.each(function(index, dropDown) {
            var dropDown = angular.element(dropDown);
            var toggle = false;

            // If the scroll-height exceeds the innerheight have a dropdown
            // overflow situation
            if ((dropDown.find('ul')[0] &&
                dropDown.find('ul')[0].scrollHeight > dropDown.innerHeight())) {
              toggle = true;
            }
            dropDown.toggleClass(overflow_css_class, toggle);
          });
        };
      }
    ])

    .service("PageTitleManager", ["$rootScope", "$location", "$filter",
      function($rootScope, $location, $filter) {
        $rootScope.$watch(function() {
          return $location.path();
        }, function() {
          var regExUUIDCheck = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
          var pathSplit = $location.path().split("?")[0].split("/").filter(Boolean);
          if (pathSplit && pathSplit.length > 0) {
            if (pathSplit[pathSplit.length - 1].match(regExUUIDCheck)) {
              $rootScope.currentUrl = "/" + pathSplit[pathSplit.length - 2];
            } else {
              var translation = $filter("translate")(pathSplit[pathSplit.length - 1]);
              if (translation !== pathSplit[pathSplit.length - 1] || pathSplit.length < 2) {
                $rootScope.currentUrl = "/" + pathSplit[pathSplit.length - 1];
              } else {
                $rootScope.currentUrl = "/" + pathSplit[pathSplit.length - 2];
              }
            }
          }
        });
      }
    ])

    .service("AutoCloseModelOnNavChange", ["$rootScope",
      function($rootScope) {
        $rootScope.$on("$locationChangeStart", function() {
          angular.element("body").removeClass("modal-open");
          angular.element(".modal-backdrop").remove();
        });
      }
    ])

    .service("PrintixRequestHeaderManager", ["$translate", "$filter", "$window",
      function($translate, $filter, $window) {
        return {
          "request": function(config) {

            if (config.method === 'GET') {
              if (config.url.indexOf("match=") > -1) {
                config.url = config.url.replace(/(match=)([^&]*)/, function(_, param, value) {
                  return param + $window.encodeURIComponent(value);
                });
              }
            }

            if (config.method === 'POST') {
              //We need to URI encode the query param, "match" to ensure spaces are escaped.
              if (config.data && typeof config.data !== 'string' && config.url.indexOf("match=") > -1) {
                config.url = config.url.replace(/(match=)([^&]*)/, function(_, param, value) {
                  return param + $window.encodeURIComponent(value);
                });
              }
            }

            if (config.url.indexOf(".html") < 0 && config.url.indexOf(".js") < 0) {
              if (!config.headers) {
                config.headers = {};
              }
              if (!config.headers["Content-Type"]) {
                config.headers["Content-Type"] = "application/json";
                //if the request method is PATCH - change the Content-Type header to the PATCH header
                if ($filter("lowercase")(config.method) === "patch") {
                  config.headers["Content-Type"] = "application/json-patch+json";
                }
              }

              //add Accept-Language header to all requests
              config.headers["Accept-Language"] = $translate.use();
            }

            // Introducing customHeaders, an option that enables adding custom headers to the request
            // Printer debugMode require that getAuditEvents always has "Accept-Language" header set to "en"
            // This is a workaround to prevent the printer debugMode not to have mixed languages
            if (config.customHeaders) {
              for (let key in config.customHeaders) {
                config.headers[key] = config.customHeaders[key];
              }
            }
            return config;
          }
        };
      }
    ])

    .service('TemplateResolver', ['$injector', function ($injector) {
      let manifest = null;

      this.getTemplateUrl = function (templateUrl) {
          if (!manifest) {
              // Lazily inject $http to avoid circular dependency
              const $http = $injector.get('$http');
              return $http.get('./asset-manifest.json').then(response => {
                  manifest = response.data;
                  return manifest[templateUrl] || templateUrl;
              });
          }
          return Promise.resolve(manifest[templateUrl] || templateUrl);
      };
    }])

    .factory('templateCacheBusterInterceptor', ['$q', 'TemplateResolver', function ($q, TemplateResolver) {
      const cacheBuster = `v=${__webpack_hash__ || Date.now()}`;

      // List of templates to exclude from appending ?v=hash
      const excludedTemplates = [
          'list.html',
          'folder.html',
          'file.html',
          'tree.html',
          'site.html',
          'rzSliderTpl.html',
          'select.tpl.html',
          'match.tpl.html',
          'choices.tpl.html',
          'toast.html',
          'accept.html'
      ];

      return {
          request: function (config) {
              if (config.url.endsWith('.html') && !config.url.includes(`v=`)) {

                    const isExcluded = excludedTemplates.some(template => {
                      return config.url.split('/').pop().includes(template);
                    });

                  if (isExcluded) {
                      return config;
                  }

                  return TemplateResolver.getTemplateUrl(config.url).then(resolvedUrl => {
                      const separator = resolvedUrl.includes('?') ? '&' : '?';
                      config.url = `${resolvedUrl}${separator}${cacheBuster}`;
                      return config;
                  });
              }
              return config;
          },
          responseError: function (rejection) {
              return $q.reject(rejection);
          }
      };
  }])

    .service("ArrayPrototypes", ["$filter", "Utils", function($filter, Utils) {
      var elementRequiredProperties = ["info", "info._links", "info._links.self", "info._links.self.href"];

      Array.prototype.add = function(element, ignoreDuplicateCheck) {
        if (element !== null) {
          if (Utils.objectPropertiesCheck(element, elementRequiredProperties)) {
            if (!this.contains({
                info: {
                  _links: {
                    self: {
                      href: element.info._links.self.href
                    }
                  }
                }
              }) || ignoreDuplicateCheck) {
              this.push(element);
            } else {
            }
          } else {
            if (!this.contains(element) || ignoreDuplicateCheck) {
              this.push(element);
            } else {
            }
          }
        } else {
          throw "Array.prototype.add: element is missing ";
        }
      };

      Array.prototype.addAll = function(array) {
        if (array) {
          this.push.apply(this, array);
        } else {
          throw "Array.prototype.addAll: array is missing";
        }
      };

      Array.prototype.remove = function(element) {
        var indexOfElement = this.indexOf(element);
        if (indexOfElement > -1) {
          this.splice(indexOfElement, 1);
        }
      };

      Array.prototype.removeWith = function(criteria) {
        var array = this;
        angular.forEach(this.findAllElements(criteria), function(element) {
          array.remove(element);
        });
      };

      Array.prototype.contains = function(criteria) {
        if (this.findAllElements(criteria).length > 0) {
          return true;
        } else {
          return false;
        }
      };

      Array.prototype.findElement = function(criteria, notStrict) {
        if (JSON.stringify(criteria) && JSON.stringify(criteria).indexOf("href") > -1) {
          return $filter("filter")(this, domainlessObjectFilter(criteria), notStrict ? false : true)[0];
        } else {
          return $filter("filter")(this, criteria, notStrict ? false : true)[0];
        }
      };

      Array.prototype.findAllElements = function(criteria, notStrict) {
        if (JSON.stringify(criteria) && JSON.stringify(criteria).indexOf("href") > -1) {
          return $filter("filter")(this, domainlessObjectFilter(criteria), notStrict ? false : true);
        } else {
          return $filter("filter")(this, criteria, notStrict ? false : true);
        }
      };

      function domainlessObjectFilter(criteria) {
        return function(item) {
          var itemCopy = angular.copy(item);
          var criteriaCopy = changeCritariaURLDomain(itemCopy, angular.copy(criteria));
          return $filter("filter")([itemCopy], criteriaCopy, true).length > 0;
        }
      }

      function changeCritariaURLDomain(item, criteria) {
        var criteriaCopy = angular.copy(criteria);
        if (item && JSON.stringify(criteriaCopy) && JSON.stringify(criteriaCopy).indexOf("href") > -1) {
          var itemCopy = angular.copy(item);
          if (itemCopy.info) {
            itemCopy = itemCopy.info;
          }
          var domainPrefixItem = null;
          if (itemCopy._links && itemCopy._links.self && itemCopy._links.self.href) {
            domainPrefixItem = itemCopy._links.self.href.split("/tenants")[0];
          } else if (itemCopy.href) {
            domainPrefixItem = itemCopy.href.split("/tenants")[0];
          } else {
            throw "changeCritariaURLDomain: itemCopy does not have _links.self.href or href";
          }
          var criteriaCopyAsString = JSON.stringify(criteriaCopy);
          var criteriaCopyAsStringCopy = angular.copy(criteriaCopyAsString);
          var domainPrefixCriteria = criteriaCopyAsStringCopy.substring(criteriaCopyAsStringCopy.lastIndexOf('https://'), criteriaCopyAsStringCopy.lastIndexOf("/tenants"));
          criteriaCopyAsString = criteriaCopyAsString.replace(domainPrefixCriteria, domainPrefixItem);
          criteriaCopy = JSON.parse(criteriaCopyAsString);
        }
        return criteriaCopy
      }
    }]);
})();
